import {call, put, select} from "redux-saga/effects";
import {
  resetUsers, setAdminFeatures,
  setCurrentPage,
  setManageUserModals,
  setUsers,
  updateUserData
} from "../../slices/manageUserSlice";
import {
  deleteFeaturesFromUsers,
  getAdminFeatures,
  getAdminUsers, getUserProfile, patchUpdateUsersPassword,
  postFeaturesToUsers,
  postOrPutAdminUsers,
  putAdminUsers, putFeaturesToUsers, putProfile
} from "../requests/userService";
import {setLoading as setDynamicLoading} from "../../slices/dynamicElementsSlice";
import {toast} from "react-toastify";
import {
  ADMIN_USERS,
  ADMIN_USERS_ITEMS_PER_PAGE,
  USER_STATE_ACTIVE, USER_STATE_CREATED,
  USER_STATE_INACTIVE
} from "../../../pages/user/constants";
import {setUserProfile} from "../../slices/authTokenSlice";
import {getAuthToken, updateAuthToken} from "../../../helpers/helperFunctions";
import {isEqual} from "lodash";

function* handleGetAdminUsers(action) {
  try {

    const selectedTab = yield select((state) => state.manageUser.selectedTab);
    let currentPage = action.payload?.page ?? 1;

    const storedData = yield select((state) => state.manageUser[selectedTab].pageData[currentPage]);

    if (storedData?.init) {
      yield put(setCurrentPage({page: currentPage}));
    } else {
      yield put(setUsers({loading: true, page: currentPage}));

      const fetchedFeatures = yield select((state) => state.manageUser.features.init);
      if (!fetchedFeatures) {
        const {
          data: features
        } = yield call(() => getAdminFeatures());

        yield put(setAdminFeatures({features}));
      }

      const {
        data: {
          data,
          total_results,
          page
        }
      } = yield call(() => getAdminUsers(currentPage, selectedTab === ADMIN_USERS));
      const totalPages = Math.floor(total_results / ADMIN_USERS_ITEMS_PER_PAGE) + (total_results % ADMIN_USERS_ITEMS_PER_PAGE === 0 ? 0 : 1);


      yield put(setUsers({data, totalPages, page}));
    }


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    yield put(setUsers({error: errorMsg}));
  }
}

function* handleAddOrUpdateAdminUsers(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: isEdit, ext: {fromProfile = false} = {}} = yield select((state) => state.manageUser.modals.form);

    const _user = yield select((state) => state.authToken.user);
    const isMyProfile = _user.id === isEdit?.id;

    let user;
    if (fromProfile) {
      const {data} = yield call(() => putProfile(action.payload));
      user = data;
    } else {
      const {data} = yield call(() => postOrPutAdminUsers(isEdit?.id, action.payload));
      user = data;
    }


    if (isEdit) {


      if (isMyProfile) {
        if (!isEqual({..._user, last_active: ""}, {...user, last_active: ""})) {
          yield put(setUserProfile({user}));
          updateAuthToken({user});
        }

      }
      if (!fromProfile) {
        yield put(updateUserData({user}));
      }


      toast.success(fromProfile ? 'Profile Updated Successfully.' : 'User Updated Successfully.');


    } else {
      yield put(resetUsers());
      toast.success('User Added Successfully.');
    }

    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageUserModals());

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

function* handleUpdateUsersState() {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {user, feature, verify} = yield select((state) => state.manageUser.modals.confirm.data);

    if (feature) {

      const userHasFeature = user.features.some((f) => f.id === feature.id);
      if (userHasFeature) {
        const {data} = yield call(() => deleteFeaturesFromUsers(user.id, feature.id));
        yield put(updateUserData({user: data}));
      } else {
        const {data} = yield call(() => putFeaturesToUsers(user.id, [feature.id]));
        yield put(updateUserData({user: data}));
      }

      toast.success(userHasFeature ? 'Successfully revoked the access to the feature.' : 'Successfully added feature to the user.');


    } else if (verify) {
      const {data} = yield call(() => putAdminUsers(user.id, {state: USER_STATE_ACTIVE, email_verified: true}));
      toast.success('Successfully Verified Manually');
      yield put(updateUserData({user: data}));
    } else {
      //todo remove CREATED state from following condition
      const {data} = yield call(() => putAdminUsers(user.id, {state: user.state === USER_STATE_ACTIVE || user.state === USER_STATE_CREATED ? USER_STATE_INACTIVE : USER_STATE_ACTIVE}));
      // yield delay(2000)

      toast.success(data.state === USER_STATE_ACTIVE ? 'User Activated Successfully.' : 'User Deactivated Successfully.');
      yield put(resetUsers());
    }
    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageUserModals());


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

function* handleGetUsersProfile() {
  try {
    const {data: user} = yield call(() => getUserProfile());

    const storedProfile = getAuthToken()?.user;

    if (!isEqual({...user, last_active: ""}, {...storedProfile, last_active: ""})) {
      yield put(setUserProfile({user}));
      updateAuthToken({user});
    }


  } catch (e) {
    // const errorMsg = e.response ? e.response.data.message : e.message;
    // yield put(setDynamicLoading({loading: false, element}));
  }
}

function* handleUpdateUserFeatures(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: user} = yield select((state) => state.manageUser.modals.feature);


    const {data} = yield call(() => postFeaturesToUsers(user.id, action.payload.features.map((f) => f.id)));
    yield put(updateUserData({user: data}));


    toast.success('Successfully modified permissions.');


    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageUserModals());


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

function* handleUpdateUsersPassword(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    // const {data: user} = yield select((state) => state.manageUser.modals.feature);

    const {data} = yield call(() => patchUpdateUsersPassword(action.payload));

    // yield put(updateUserData({user: data}));


    toast.success('Successfully updated your password.');


    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageUserModals());


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}


export {
  handleGetAdminUsers,
  handleAddOrUpdateAdminUsers,
  handleUpdateUsersState,
  handleGetUsersProfile,
  handleUpdateUserFeatures,
  handleUpdateUsersPassword
};
